import React, { Component } from 'react';
import Inherit from '../../core/inherit';
import PollsController from './polls.controller';
import withNavigate from '../../core/withNavigate';
import { ClipboardCheck } from 'lucide-react';

import { Layout, TableSkeleton, AnalyticsSkeleton, PageHeader } from '../common';
import { PollTable, PollAnalytics, PollFilters, EMPTY_POLL_FILTERS } from './elements';
import { t } from '../../company/labels';
import { isFeatureEnabled } from '../../company/session';
import { FEATURES } from '../../company/features';

class ShelfPolls extends Inherit(PollsController, Component) {
    state = {
        loading: true,
        polls: [],
        filters: EMPTY_POLL_FILTERS
    };

    render() {
        const { polls, loading, filters } = this.state;
        const filteredPolls = this.getFilteredPolls();

        return (
            <Layout current="polls">
                <PageHeader
                    icon={<ClipboardCheck />}
                    title={t('pollsTitle')}
                    description={t('pollsDescription')}
                />

                {loading ? (
                    <div className="space-y-4">
                        <AnalyticsSkeleton count={3} />
                        <TableSkeleton rows={10} columns={5} />
                    </div>
                ) : (
                    <div className="space-y-4">
                        <PollFilters polls={polls} filters={filters} onChange={(next) => this.setFilters(next)} />

                        {/* Analytics (reflect the active filters) */}
                        <PollAnalytics polls={filteredPolls} />

                        <PollTable polls={filteredPolls} loading={loading} onDelete={isFeatureEnabled(FEATURES.POLL_DELETE) ? (id) => this.deletePoll(id) : undefined} />
                    </div>
                )}
            </Layout>
        );
    }
}

export default withNavigate(ShelfPolls);
